module.exports = __webpack_public_path__ + "img/27.dd3935e1.jpg";